import React from 'react';
import { useTranslation } from 'react-i18next';

import UserdocsLink, { USERDOCS_HOST } from 'cityads-v3/components/Links/UserdocsLink';

import classNames from './ExportPopup.scss';

export default function ExportPopupFooter(): JSX.Element {
  const { t } = useTranslation(['Offers']);

  return (
    <div className={classNames.footer}>
      {t('exports.learnMore')}
      <br/>
      <UserdocsLink href={'/content/tools/coupon.html#coupon-feed-link'} languages={['en', 'ru']}>{USERDOCS_HOST}</UserdocsLink>
    </div>
  );
}
